import useLenis from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import CookieConsent from "@/components/site/CookieConsent";

export default function SiteLayout({ children }) {
  useLenis();
  return (
    <div className="App relative min-h-screen">
      <Header />
      <main className="pt-[74px]">{children}</main>
      <Footer />
      <Chatbot />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}
